// @flow

import * as React from 'react';
import { InDestinationRedirect } from '@ta/social.in-destination';
import { Icon } from '@ta/styleguide.icon';
import Button from '@ta/styleguide.button';

import styles from './LocationPermissionSection.less';

type Props = {|
  item: any,
|};

/** A Section in the feed that will prompt the user to enable location permission */
const LocationPermissionSection = ({ item }: Props) => (
  <div className={`ui_card ${styles.container}`}>
    <div className="ui_container">
      <div className={styles.header}>{item.title}</div>
      <div className={styles.body}>{item.text}</div>
      <div>
        <InDestinationRedirect>
          {redirectFunction => (
            <Button type="secondary" onClick={redirectFunction}>
              <div>
                <Icon name="nearby-fill" className={styles.icon} />
                <span>{item.button}</span>
              </div>
            </Button>
          )}
        </InDestinationRedirect>
      </div>
    </div>
  </div>
);

export default LocationPermissionSection;
